import React from 'react'
import { jcmdRegistry } from '../lib/JCMDRegistry'

const JCMDHistory: React.FC = () => {
  const [executions, setExecutions] = React.useState(jcmdRegistry.getAllExecutions())
  const [refreshKey, setRefreshKey] = React.useState(0)

  // 定期刷新执行记录
  React.useEffect(() => {
    const interval = setInterval(() => {
      setExecutions(jcmdRegistry.getAllExecutions())
      setRefreshKey(prev => prev + 1)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'text-green-600 bg-green-100'
      case 'failed':
        return 'text-red-600 bg-red-100'
      case 'executing':
        return 'text-blue-600 bg-blue-100'
      case 'pending':
        return 'text-yellow-600 bg-yellow-100'
      default:
        return 'text-gray-600 bg-gray-100'
    }
  }

  const getStatusText = (status: string) => {
    switch (status) {
      case 'completed':
        return '完成'
      case 'failed':
        return '失败'
      case 'executing':
        return '执行中'
      case 'pending':
        return '等待中'
      default:
        return '未知'
    }
  }

  const formatTime = (timestamp: number) => {
    return new Date(timestamp).toLocaleTimeString()
  }

  if (executions.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        暂无执行记录
      </div>
    )
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">JCMD 执行历史</h3>
        <button
          onClick={() => setRefreshKey(prev => prev + 1)}
          className="px-3 py-1 bg-gray-500 text-white text-sm rounded hover:bg-gray-600 transition-colors"
        >
          刷新
        </button>
      </div>
      
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {executions.map((execution) => (
          <div
            key={execution.id}
            className="border rounded-lg p-3 bg-white shadow-sm"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2">
                <span className="font-mono text-sm font-semibold">
                  {execution.command}
                </span>
                <span className={`px-2 py-1 rounded text-xs font-medium ${getStatusColor(execution.status)}`}>
                  {getStatusText(execution.status)}
                </span>
              </div>
              <span className="text-xs text-gray-500">
                {formatTime(execution.timestamp)}
              </span>
            </div>

            {/* 参数 */}
            <div className="mb-2">
              <div className="text-xs font-semibold text-gray-600 mb-1">参数:</div>
              <pre className="text-xs bg-gray-50 p-2 rounded overflow-x-auto">
                {JSON.stringify(execution.params, null, 2)}
              </pre>
            </div>

            {/* 内容 */}
            {execution.content && (
              <div className="mb-2">
                <div className="text-xs font-semibold text-gray-600 mb-1">内容:</div>
                <div className="text-xs bg-gray-50 p-2 rounded">
                  {execution.content}
                </div>
              </div>
            )}

            {/* 结果 */}
            {execution.result && (
              <div className="mb-2">
                <div className="text-xs font-semibold text-gray-600 mb-1">结果:</div>
                <pre className="text-xs bg-gray-50 p-2 rounded overflow-x-auto">
                  {JSON.stringify(execution.result, null, 2)}
                </pre>
              </div>
            )}

            {/* 错误 */}
            {execution.error && (
              <div className="mb-2">
                <div className="text-xs font-semibold text-red-600 mb-1">错误:</div>
                <div className="text-xs bg-red-50 p-2 rounded text-red-700">
                  {execution.error}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default JCMDHistory 